import { Localized } from "@fluent/react"
import { DialogTitle, DialogContent, DialogContentText, DialogActions, Alert, Typography, TextField } from "@mui/material"
import { useAppDispatch } from "../../../app/hooks";
import { useState } from "react";
import { AppUser, unarchiveAppUser } from "../administration";
import { showSuccess } from "../../notifications/notificationsSlice";
import { CancelButton } from "../../../app/components/CancelButton";
import { RestoreButton } from "../../../app/components/RestoreButton";

export interface UnarchiveUserDialogProps {
    email: string;
    onSuccessfullySaved: (updated: any) => void;
    onCancel: () => void
}

export const UnarchiveUserDialog = ({ email, onSuccessfullySaved, onCancel }: UnarchiveUserDialogProps) => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState<boolean>(false);
    const [reason, setReason] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [serverError, setServerError] = useState("");

    const handleSubmitClick = async() => {
        try {
            setLoading(true)
            const result = await dispatch(unarchiveAppUser({ email, reason, password }));
            if (unarchiveAppUser.fulfilled.match(result)) {
                result.payload as AppUser;
                dispatch(showSuccess("saved"))
                onSuccessfullySaved({ status: "ACTIVE", lockedAt: "", lockedBy: "", lockReason: "" });
            }
            else {
                let errorMsg = "error"
                if (result.payload) {
                    if (result.payload.kind === 'http') {
                        const problem = result.payload.problem
                        if (problem) {
                            errorMsg = problem.title
                        }
                    }
                }
                setServerError(errorMsg)
            }
        }
        catch (error) {
            setServerError("error");
        }
        finally {
            setLoading(false)
        }
    }

    return (
        <>
            <DialogTitle>
                <Localized id="user-unarchive-dialog-title">
                    <span>_Przywróć użytkownika</span>
                </Localized>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Alert
                        severity="info"
                        variant="outlined"
                        sx={{
                            mb: 2,
                            mt: 2,
                            alignItems: "flex-start",
                            "& .MuiAlert-message": {
                                width: "100%",
                            },
                        }}
                    >
                        <Typography variant="body2">
                            <Localized id="user-unarchive-dialog-alert">
                                <span>_Treść alertu</span>
                            </Localized>
                        </Typography>
                    </Alert>

                    <TextField
                        fullWidth
                        value={reason}
                        required
                        onChange={(e) => setReason(e.target.value)}
                        type={"text"}
                        multiline
                        rows={4}
                        inputProps={{ maxLength: 1000 }}
                        label={<Localized id="user-unarchiving-reason">_Powód przywrócenia</Localized>}
                    />

                    <TextField
                        sx={{ mt: 2 }}
                        fullWidth
                        value={password}
                        required
                        onChange={(e) => setPassword(e.target.value)}
                        type={"password"}
                        label={<Localized id="password">_Hasło</Localized>}
                        helperText={<Localized id="autorization-password-required"><span>Wymagana autoryzacja hasłem</span></Localized>}
                    />
                </DialogContentText>

                {serverError && (
                    <Alert sx={{ marginTop: 1 }} severity="error">
                        <Localized id={serverError}>
                            <span style={{ whiteSpace: 'pre-line' }}>{serverError}</span>
                        </Localized>
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <RestoreButton
                    onClick={handleSubmitClick}
                    loading={loading}
                />
                <CancelButton
                    loading={loading}
                    onClick={onCancel}
                />
            </DialogActions>
        </>
    )
}